import sheaFace from "../assets/imgs/shea.png";
import sheaLeftEye from "../assets/imgs/left.png";
import sheaRightEye from "../assets/imgs/right.png";

import liamFace from "../assets/imgs/liam.JPG";
import liamLeftEye from "../assets/imgs/liam-left.PNG";
import liamRightEye from "../assets/imgs/liam-right.PNG";

import mattFace from "../assets/imgs/matt.JPG";
import mattLeftEye from "../assets/imgs/matt-left.PNG";
import mattRightEye from "../assets/imgs/matt-right.PNG";

const people = [
  {
    name: "shea",
    faceImg: sheaFace,
    leftEyeImg: sheaLeftEye,
    rightEyeImg: sheaRightEye
  },
  {
    name: "liam",
    faceImg: liamFace,
    leftEyeImg: liamLeftEye,
    rightEyeImg: liamRightEye
  },
  {
    name: "matt",
    faceImg: mattFace,
    leftEyeImg: mattLeftEye,
    rightEyeImg: mattRightEye
  },
  {
    name: "liam",
    faceImg: liamFace,
    leftEyeImg: liamLeftEye,
    rightEyeImg: liamRightEye
  },
  {
    name: "shea",
    faceImg: sheaFace,
    leftEyeImg: sheaLeftEye,
    rightEyeImg: sheaRightEye
  },
  {
    name: "matt",
    faceImg: mattFace,
    leftEyeImg: mattLeftEye,
    rightEyeImg: mattRightEye
  },
  {
    name: "shea",
    faceImg: sheaFace,
    leftEyeImg: sheaLeftEye,
    rightEyeImg: sheaRightEye
  },
  {
    name: "matt",
    faceImg: mattFace,
    leftEyeImg: mattLeftEye,
    rightEyeImg: mattRightEye
  },
  {
    name: "liam",
    faceImg: liamFace,
    leftEyeImg: liamLeftEye,
    rightEyeImg: liamRightEye
  },
  {
    name: "shea",
    faceImg: sheaFace,
    leftEyeImg: sheaLeftEye,
    rightEyeImg: sheaRightEye
  },
  {
    name: "matt",
    faceImg: mattFace,
    leftEyeImg: mattLeftEye,
    rightEyeImg: mattRightEye
  },
  {
    name: "liam",
    faceImg: liamFace,
    leftEyeImg: liamLeftEye,
    rightEyeImg: liamRightEye
  },
  
];

export default people;
